export default function getURLParam(param) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
}
